/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classnames from 'classnames';

import 'js/lib/popups';

import Icon from 'bundles/iconfont/Icon';

const styles = {
  dropdownMenu: css`
    .bt3-dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      display: none;
      float: left;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      list-style: none;
      font-size: 14px;
      background-color: var(--cds-color-neutral-background-primary);
      border: 1px solid var(--cds-color-grey-200);
      border: 1px solid rgb(0 0 0 / 15%);
      border-radius: 4px;
      -webkit-box-shadow: 0 6px 12px rgb(0 0 0 / 17.5%);
      box-shadow: 0 6px 12px rgb(0 0 0 / 17.5%);
      background-clip: padding-box;
    }

    .bt3-dropdown-menu > li > a {
      display: block;
      padding: 3px 20px;
      clear: both;
      font-weight: normal;
      line-height: 1.4286;
      color: var(--cds-color-grey-850);
      white-space: nowrap;
    }

    .bt3-dropdown-menu > li > a:hover,
    .bt3-dropdown-menu > li > a:focus {
      text-decoration: none;
      color: var(--cds-color-grey-950);
      background-color: var(--cds-color-neutral-background-primary-weak);
    }

    .bt3-dropdown-menu > .bt3-active > a,
    .bt3-dropdown-menu > .bt3-active > a:hover,
    .bt3-dropdown-menu > .bt3-active > a:focus {
      color: var(--cds-color-neutral-primary-invert);
      text-decoration: none;
      outline: 0;
      background-color: var(--cds-color-blue-500);
    }

    .bt3-open > .bt3-dropdown-menu {
      display: block;
    }

    .bt3-open > a {
      outline: 0;
    }
  `,
};

type Props = {
  dropdownId: string;
  listItems: React.ReactNode[];
  dropdownDirection?: string;
  className?: string;
  toggleClassName?: string;
  iconClassName?: string;
  iconName?: string;
  label?: string;
};

class Dropdown extends React.Component<Props> {
  static defaultProps = {
    dropdownDirection: 'se',
  };

  sanitizeId(id: $TSFixMe) {
    return id.replace(/\W/g, '');
  }

  render() {
    const { dropdownId, label } = this.props;
    const toggleClassnames = classnames('nostyle', this.props.toggleClassName);
    const iconName = this.props.iconName || 'ellipsis-h';

    const sanitizedDropdownId = this.sanitizeId(dropdownId);

    return (
      <div className={this.props.className}>
        <div css={styles.dropdownMenu}>
          <button
            aria-haspopup="true"
            aria-expanded="false"
            data-toggle="dropdown"
            aria-owns={sanitizedDropdownId}
            data-popup={`#${sanitizedDropdownId}`}
            data-popup-bind-open="click"
            data-popup-direction={this.props.dropdownDirection}
            data-popup-close="data-popup-close"
            className={toggleClassnames}
            aria-label={label}
            type="button"
          >
            {/* @ts-expect-error iconName prop is typed as string (per legacy propTypes) but Icon expects the narrower IconName union — pre-existing mismatch, behavior unchanged */}
            <Icon name={iconName} className={this.props.iconClassName} />
          </button>
          <ul className="styleguide dropdown bt3-dropdown-menu" id={sanitizedDropdownId}>
            {this.props.listItems.map((item, index) => (
              <li key={`${sanitizedDropdownId}-listItem${index}`}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Dropdown;
